<div id="wrapper" class="f-family">
  <div>
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
  </div>
  <div>
    <app-tab-nav [visible]="false" (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event"
      (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event"
      (updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
      (updateInitializeData)="this.initializeData()">
    </app-tab-nav>
  </div>
  <div *ngIf="this.itemsCart!=null" class="allcont logsize m-top-i">
    <div class="basicrow ">
      <div class="container">
        <div class="basicr-line-i">
          <div class="fulltitle  f-btitle autodef">
            <span><img width="100%" class="icon-iptv-2" src="/assets/images/icon_IPTV2.png"></span>
            <label class="clarotv2">Claro</label>
            <label class="tvmas2">tv+</label>
          </div>
        </div>
        <div class="grid-basic p-b">
          <div class="basicr-line-i m-top-i title-process">
            <div class="autodef ">
              <span class="f-big less-f">Proceso de Compra</span>
            </div>
          </div>
        </div>
        <br />
        <div class=" purchasing-process-header">
          <div></div>
          <div (click)="this.openTab(2)" class="f-w-1">
            RENTA MENSUAL
          </div>
          <div class="f-w-1">
            TOTAL A PAGAR HOY
          </div>
        </div>
        <div class="purchasing-process">
          <mat-accordion class="buy-process">
            <mat-expansion-panel [disabled]="true" [expanded]="this.expand[0]" (opened)="openTab(0)"
              (closed)="closeTab(0)">
              <mat-expansion-panel-header class="expansion-panel-header">
                <mat-panel-title class="panel-title">
                  <div class="expansion-grid">
                    <div class="process-index">
                      <div class="c-blue">
                        1
                      </div>
                    </div>
                    <div class="process-name">
                      Plan de Clarotv+
                      <span class="gentab-title-display" matTooltip={{this.selectsToDisplayFull[0]}}>{{
                        this.selectsToDisplay[0]
                        }}
                      </span>
                    </div>
                    <div class="monthly-rent f-w-1">
                      <div class="monthly-rent-movil inherit">
                        RENTA MENSUAL
                      </div>
                      <div>
                        {{this.selectMonthlyRent[0] | currency}}
                      </div>
                    </div>
                    <div class="pay-today f-w-1 pay-today-off">
                    </div>
                  </div>
                </mat-panel-title>
                <mat-icon class="icon-edit cursor" (click)="this.changeIptv(0)">edit
                </mat-icon>
              </mat-expansion-panel-header>
              <div>
                <app-plan-iptv (selectMonthlyRentOut)="this.selectMonthlyRent[0]=$event"
                  (selectsToDisplayOut)="savePlanIPTV($event,0)"
                  (selectsToDisplayFullOut)="this.selectsToDisplayFull[0]=$event" [itemsCart]="this.itemsCart"
                  [data]="dataPlan">
                </app-plan-iptv>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="this.expand[1]" (opened)="openTab(1)" (closed)="closeTab(1)">
              <mat-expansion-panel-header class="expansion-panel-header">
                <mat-panel-title class="panel-title">
                  <div class="expansion-grid">
                    <div class="process-index">
                      <div class="c-blue">
                        2
                      </div>
                    </div>
                    <div class="process-name">
                      Servicios Adicionales Clarotv+
                      <span class="gentab-title-display" matTooltip={{this.selectsToDisplayFull[1]}}>{{
                        this.selectsToDisplay[1]
                        }}
                      </span>
                    </div>
                    <div *ngIf="this.svaProducts==true" class="monthly-rent f-w-1">
                      <div class="monthly-rent-movil">
                        RENTA MENSUAL
                      </div>
                      <div>
                        {{this.selectMonthlyRent[1] | currency}}
                      </div>
                    </div>
                    <div class="pay-today f-w-1 pay-today-off">
                    </div>
                  </div>
                </mat-panel-title>
                <mat-icon class="icon-edit" *ngIf="!expand[1]">edit</mat-icon>
                <mat-icon class="icon-edit-off" *ngIf="expand[1]">edit_off</mat-icon>
              </mat-expansion-panel-header>
              <div id='panel_1'>
                <app-additional-service *ngIf="this.viewSVA" [currentIndex]="this.currentIndex"
                  [selectPayToday]="this.selectPayToday" [selectMonthlyRent]="this.selectMonthlyRent"
                  [selectsToDisplay]="this.selectsToDisplay" [currentParentCartId]="this.currentParentCartId"
                  [currentParentProductId]="this.currentParentProductId" [sva]="this.sva" [svaCart]="this.svaCart"
                  [itemsCart]="this.itemsCart" (resetDataSvaOut)="this.resetDataSva()"
                  (itemsCartValueOut)="this.itemsCart.totalPerMonth=$event" (continueSva)="this.continueSva($event)"
                  (selectsToDisplayOut)="this.selectsToDisplay=$event"
                  (selectMonthlyRentOut)="this.selectMonthlyRent=$event"
                  (selectPayTodayOut)="this.selectPayToday=$event" (closeTab)="closeTab($event)">
                </app-additional-service>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel [disabled]="this.disabled[2]" [expanded]="this.expand[2]" (opened)="openTab(2)"
              (closed)="closeTab(2)">
              <mat-expansion-panel-header class="expansion-panel-header">
                <mat-panel-title class="panel-title">
                  <div class="expansion-grid">
                    <div class="process-index">
                      <div class="c-blue">
                        3
                      </div>
                    </div>
                    <div class="process-name">
                      Escoge tu dispositivo de Streaming
                      <span class="gentab-title-display" matTooltip={{this.selectsToDisplayFull[2]}}>{{
                        this.selectsToDisplay[2]
                        }}
                      </span>
                    </div>
                    <div class="monthly-rent f-w-1"
                      [ngClass]="{'monthly-rent-off': (this.contract==false || this.itemsCart.bitEquipmentValidate==false ) }">
                      <div *ngIf="this.contract" class="monthly-rent-movil">
                        RENTA MENSUAL
                      </div>
                      <div>
                        <div *ngIf="this.selectMonthlyRent[2]> 0 && (this.installments > 0)">
                          {{this.selectMonthlyRent[2] | currency}}
                        </div>
                        <div *ngIf="this.selectMonthlyRent[2]==0 && this.contract==true">
                          Gratis
                        </div>
                      </div>
                    </div>
                    <div class="pay-today f-w-1"
                      [ngClass]="{'pay-today-off': (this.contract==true || this.itemsCart.bitEquipmentValidate==false)}">
                      <div *ngIf="this.contract==false" class="pay-today-movil">
                        PAGA HOY
                      </div>
                      <div *ngIf="this.selectPayToday[2] > 0 && (this.installments == 0)">
                        {{this.selectPayToday[2] | currency}}
                      </div>
                    </div>
                  </div>
                </mat-panel-title>
                <mat-icon class="icon-edit" *ngIf="!expand[3]">edit</mat-icon>
                <mat-icon class="icon-edit-off" *ngIf="expand[3]">edit_off</mat-icon>
              </mat-expansion-panel-header>
              <div id='panel_3'>
                <app-streaming-device *ngIf="this.streamingActive==true" [infoStreaming]="this.infoStreaming"
                  (next)="this.continueStreaming($event)" [indexTab]="2" [itemsCart]="this.itemsCart"
                  [selectsToDisplay]="this.selectsToDisplay"
                  (selectsToDisplayFullOut)="this.selectsToDisplayFull=$event"
                  (selectsToDisplayOut)="this.selectsToDisplay=$event" [selectMonthlyRent]="this.selectMonthlyRent"
                  (selectMonthlyRentOut)="this.selectMonthlyRent=$event" [selectPayToday]="this.selectPayToday"
                  (selectPayTodayOut)="this.selectPayToday=$event">
                </app-streaming-device>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel [disabled]="this.disabled[3]" [expanded]="this.expand[3]" (opened)="openTab(3)"
            (closed)="closeTab(3)">
            <mat-expansion-panel-header class="expansion-panel-header">
              <mat-panel-title class="panel-title">
                <div class="expansion-grid-email">
                  <div class="process-index">
                    <div class="c-blue">
                      4
                    </div>
                  </div>
                  <div class="process-name">
                    Crea tu cuenta
                    <span class="gentab-title-display" matTooltip={{this.selectsToDisplayFull[5]}}>{{
                      this.selectsToDisplay[5]
                      }}
                    </span>
                  </div>
                </div>
              </mat-panel-title>
              <mat-icon class="icon-edit" *ngIf="!expand[2]" (click)="editProcess(2,true)">edit</mat-icon>
              <mat-icon class="icon-edit-off" *ngIf="expand[2]" (click)="editProcess(2,false)">edit_off</mat-icon>
            </mat-expansion-panel-header>
            <div id='panel_2'>
              <app-create-account-iptv class="contspad" [indexTab]="5" [selectsToDisplay]="this.selectsToDisplay"
                (selectsToDisplayOut)="this.selectsToDisplay=$event" (nextTabOut)="this.saveAccountIptv()">
              </app-create-account-iptv>
            </div>
          </mat-expansion-panel>
            <mat-expansion-panel [disabled]="this.disabled[4]" [expanded]="this.expand[4]" (opened)="openTab(4)"
              (closed)="closeTab(4)">
              <mat-expansion-panel-header class="expansion-panel-header">
                <mat-panel-title class="panel-title">
                  <div class="expansion-grid">
                    <div class="process-index">
                      <div class="c-blue">
                        5
                      </div>
                    </div>
                    <div class="process-name">
                      Información de Pago
                      <span class="gentab-title-display" matTooltip={{this.selectsToDisplayFull[3]}}>{{
                        this.selectsToDisplay[3]
                        }}
                      </span>
                    </div>
                    <div class="monthly-rent f-w-1">
                    </div>
                    <div class="pay-today f-w-1">
                    </div>
                  </div>
                </mat-panel-title>
                <mat-icon class="icon-edit" *ngIf="!expand[4]">edit</mat-icon>
                <mat-icon class="icon-edit-off" *ngIf="expand[4]">edit_off</mat-icon>
              </mat-expansion-panel-header>
              <div id='panel_4'>
                <app-payment-shipping (validate)="this.paymentValidation=$event"
                  (selectsToDisplayOut)="savePaymentShipping($event,3)">
                </app-payment-shipping>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel [disabled]="this.disabled[5]" [expanded]="this.expand[5]" (opened)="openTab(5)"
              (closed)="closeTab(5)">
              <mat-expansion-panel-header class="expansion-panel-header">
                <mat-panel-title class="panel-title">
                  <div class="expansion-grid">
                    <div class="process-index">
                      <div class="c-blue">
                        6
                      </div>
                    </div>
                    <div class="process-name">
                      Información de Envío
                      <span class="gentab-title-display" matTooltip={{this.selectsToDisplayFull[4]}}>{{
                        this.selectsToDisplay[4]
                        }}
                      </span>
                    </div>
                    <div class="monthly-rent f-w-1">
                    </div>
                    <div class="pay-today f-w-1">
                    </div>
                  </div>
                </mat-panel-title>
                <mat-icon class="icon-edit" *ngIf="!expand[5]">edit</mat-icon>
                <mat-icon class="icon-edit-off" *ngIf="expand[5]">edit_off</mat-icon>
              </mat-expansion-panel-header>
              <div id='panel_5'>
                <app-shipping-address [ite] (validate)="this.shippingValidation=$event"
                  (closeTab)="saveShippingAddress(5)" [selectsToDisplay]="this.selectsToDisplay"
                  [itemsCart]="this.itemsCart" (selectsToDisplayOut)="this.selectsToDisplay=$event" [indexTab]="4">
                </app-shipping-address>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <div class="purchase-details">
          <div class="sub-total separate-c-last">
            <div class="sub-total-grid">
              <div class="title-sub-total">
                SUBTOTAL
              </div>
              <div class="value-sub-total">
                {{this.itemsCart.subTotalPerMonth | currency}}
              </div>
              <div class="value-sub-total">
                {{this.itemsCart.subTotalPrice | currency}}
              </div>
            </div>
          </div>
          <div>
            <app-order-summary [itemsCart]="this.itemsCart"></app-order-summary>
          </div>
          <div class="basicrow btn-div">
            <div class="btn-continue" (click)="this.checkOrder()">
              <div id="panel_6" class="btntxt din-b">
                PROCESAR ORDEN
                <img width="100%" class="btnicon" src="/assets/images/btnicon02.png">
              </div>
            </div>
            <div class="btn-gray">
              <div class="btntxt din-b" (click)="this.back()">
                REGRESAR
                <img width="100%" class="btnicon-back" src="/assets/images/btnicon03.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
